import Grid from '@mui/material/Grid2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RecyclingIcon from '@mui/icons-material/Recycling';
import backgroundSection3 from "../../../../images/backgroundSection3.jpg";

const BENEFITS = [
  "Mayor credibilidad frente a clientes",
  "Registro ordenado de operaciones",
  "Acceso a certificación validada",
];

function ManagersSection() {
  return (
    <section
      className="bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: `linear-gradient(rgba(14,30,80,0.88),rgba(14,30,80,0.88)), url(${backgroundSection3})` }}
    >
      <div className="max-w-[1200px] mx-auto py-96 px-40">
        <Grid container spacing={6} alignItems="center">

          <Grid size={{ xs: 12, md: 5 }}>
            <div className="bg-white/[0.06] border border-white/15 rounded-20 h-full min-h-[380px] flex flex-col items-center justify-center py-48 px-32 text-center">
              <RecyclingIcon className="!text-60 text-[rgba(56,189,248,0.3)] mb-24" />
              <p className="text-18 text-white/70 leading-[1.6]">
                Convierte cada operación en evidencia confiable y certifica el material que gestionas.
              </p>
            </div>
          </Grid>

          <Grid size={{ xs: 12, md: 7 }}>
            <div className="inline-flex items-center gap-8 bg-[rgba(56,189,248,0.15)] text-[#38BDF8] font-bold text-14 tracking-[0.06em] uppercase py-6 px-16 rounded-full mb-24 border border-[rgba(56,189,248,0.3)]">
              <RecyclingIcon className="!text-18" />
              Gestores
            </div>

            <h2 className="text-40 font-extrabold text-white leading-[1.2] mb-24">
              Convierte tu operación en valor certificado
            </h2>

            <p className="text-20 text-white/80 leading-[1.75] mb-40 max-w-[600px]">
              Registra la gestión del material de forma estructurada y genera evidencia confiable del proceso.
            </p>

            <p className="text-14 font-bold text-[#38BDF8] mb-16 uppercase tracking-[0.06em]">
              Beneficios
            </p>
            <ul className="list-none p-0 m-0">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-14 text-18 text-white/90 py-12 border-b border-white/10 last:border-b-0">
                  <CheckCircleIcon className="!text-20 text-[#38BDF8] shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
          </Grid>

        </Grid>
      </div>
    </section>
  );
}

export default ManagersSection;
